import { message } from 'antd';
import { openUrlExternally } from '../../utils/jsbridge';

export const openWxminiShop = async (accId, shopId) => {
    // console.log('shopId', currentShopId);

    const response = await fetch(`/api/wxopen/wx-mini-url`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            accId,
            shopId,
        })
    });
    const result = await response.json();

    if(result.success) {
        openUrlExternally(result.data.url_link);
    }else {
        message.error('获取小程序链接失败！');
    }
}